export default {
    abs: "abs",
    activate: "Activate",
    add_category: "Add category",
    add_kit: "Add kit",
    additional_materials: "Additional materials",
    archive: "Archive",
    are_you_sure_you_want_to_delete_category: "Are you sure you want to delete this category?",
    are_you_sure_you_want_to_delete_service: "Are you sure you want to delete this service?",
    assistant_reward: "Assistant's remuneration",
    average_price: "Average price",
    categories: "Categories",
    category: "Category",
    change_category: "Change category",
    change_pricelist: "Change pricelist",
    classificator_code: "Classificator code",
    classificator_title: "Classificator title",
    complex_service: "Complex service",
    complex_services: "Complex services",
    curator_reward: "Curator's remuneration",
    current_value: "Current price",
    deactivate: "Deactivate",
    decrease_price: "Decrease price",
    discounted_price: "Discounted price",
    do_not_accrue_bonus: "Do not accrue bonuses",
    doctor_reward: "Doctor's reward",
    fill_from_previous_visits: "Fill in from previous visits",
    fixed_materials_expense_sum: "Fixed materials expense sum",
    import_standard_services: "Import of standard services",
    increase_price: "Increase price",
    individual_bonus: "Individual bonus to patient (%)",
    make_separate: "Make it separate",
    manager: "Manager",
    manager_reward: "Manager reward",
    mkb_10_diagnosis: "Diagnosis according to ICD 10",
    money_lost_on_discount: "Money lost on discount",
    move_to_group: "Move to group",
    ndfl_code: "NDFL code",
    not_selected: "Not specified",
    packages_cost: "Prime cost of the packages",
    personal_percent_for_assistant: "Assistant's personal interest",
    personal_percent_for_curator: "Curator's personal interest",
    personal_percent_for_doctor: "Doctor's personal interest",
    personal_percent_for_manager: "Manager's personal interest",
    personal_percent_for_technic: "Technician's personal interest",
    price_can_be_changed: "Price can be changed in the treatment card",
    price_from: "Price from",
    pricelist_price: "Pricelist price",
    pricelist_short: "Pricelist",
    reset_selection: "Reset selection",
    send_to_archive: "Send to archive",
    Service: "Service",
    service_category: "Category",
    service_code: "Service code",
    services_not_selected: "No services selected",
    technic: "Technician",
    technic_reward: "Technician's reward",
    teeth_not_selected: "No teeth selected",
    use_visit_anamnez: "Use the visit history",
    visit_status: "Visit status"
}
